import { frontendURL } from 'dashboard/helper/URLHelper';
import { WEB_ORDER_PRODUCT_ACCESS_PERMISSIONS } from 'dashboard/constants/permissions';

const inventoryMeta = permission => ({
  permissions: ['administrator', permission],
});

const productsMeta = {
  permissions: ['administrator', ...WEB_ORDER_PRODUCT_ACCESS_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/inventory/stock'),
    name: 'inventory_stock',
    component: () => import('./pages/StockPage.vue'),
    meta: inventoryMeta('inventory_stock'),
  },
  {
    path: frontendURL('accounts/:accountId/inventory/stock/adjust'),
    name: 'inventory_stock_adjust',
    component: () => import('./pages/BulkAdjustPage.vue'),
    meta: inventoryMeta('inventory_stock'),
  },
  {
    path: frontendURL('accounts/:accountId/inventory/warehouses'),
    name: 'inventory_warehouses',
    component: () => import('./pages/WarehousesPage.vue'),
    meta: inventoryMeta('inventory_warehouses'),
  },
  {
    path: frontendURL('accounts/:accountId/inventory/products'),
    name: 'inventory_products',
    component: () => import('../webOrder/pages/ProductsPage.vue'),
    meta: productsMeta,
  },
  {
    path: frontendURL('accounts/:accountId/inventory/products/new'),
    name: 'inventory_product_new',
    component: () => import('./pages/ProductDetailPage.vue'),
    meta: {
      permissions: ['administrator', 'web_order_product_create'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/inventory/products/:productId'),
    name: 'inventory_product_detail',
    component: () => import('./pages/ProductDetailPage.vue'),
    meta: productsMeta,
  },
  {
    path: frontendURL('accounts/:accountId/inventory/vendors'),
    name: 'inventory_vendors',
    component: () => import('./pages/VendorsPage.vue'),
    meta: inventoryMeta('inventory_vendors'),
  },
  {
    path: frontendURL('accounts/:accountId/inventory/purchases'),
    name: 'inventory_purchases',
    component: () => import('./pages/PurchasesPage.vue'),
    meta: inventoryMeta('inventory_purchases'),
  },
  {
    path: frontendURL('accounts/:accountId/inventory/bills'),
    name: 'inventory_bills',
    component: () => import('./pages/BillsPage.vue'),
    meta: inventoryMeta('inventory_bills'),
  },
  {
    path: frontendURL('accounts/:accountId/inventory/logs'),
    name: 'inventory_logs',
    component: () => import('./pages/LogsPage.vue'),
    meta: inventoryMeta('inventory_logs'),
  },
];
